.root {
  position: fixed;
  inset-block-end: var(--space-4);
  inset-inline-end: var(--space-4);
  z-index: var(--z-toast);

  display: flex;
  flex-direction: column;
  gap: var(--space-2);

  inline-size: min(22rem, calc(100vw - var(--space-8)));
  padding: var(--space-3);

  background: var(--md-surface);
  border-radius: var(--shape-md);
  box-shadow: var(--elevation-3);
}

/* ─── Detailed list (default above the summary breakpoint) ─── */

.list {
  display: none;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.thumb {
  flex: 0 0 auto;
  inline-size: 2.5rem;
  border-radius: var(--shape-xs);
  overflow: hidden;
}

.rowBody {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.rowHeading {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  min-inline-size: 0;
}

.rowHeading > :last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ─── Collapsed summary ─── */
/* Below the breakpoint a stack of cards would cover both the order list and the
   toast viewport, on the one device where the talent is most likely signing. */

.summary {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

@media (--window-medium) {
  .list {
    display: flex;
  }

  .summary {
    display: none;
  }
}
